module.exports = __webpack_public_path__ + "static/CardOfDarkness4-a69e7f364e42b8ad590fd970e6cbe146.png";